var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-overlay",
    {
      staticStyle: { "z-index": "99999" },
      attrs: { color: "#f5f5f5", opacity: "1" }
    },
    [
      _c(
        "div",
        { staticClass: "mx-3" },
        [
          _c("v-img", {
            attrs: {
              alt: "Logo Daycohost",
              width: "155",
              height: "93",
              "lazy-src": require("@/assets/daycohost.png"),
              src: require("@/assets/daycohost.png")
            }
          })
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mt-4", attrs: { "fill-width": "" } },
        [
          _c("v-progress-linear", {
            attrs: {
              active: "",
              color: _vm.color,
              indeterminate: "",
              rounded: "",
              height: "2",
              query: _vm.query
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }